<script>
	export default {
		props: {
			regions: Array,
			filterRegions: Array,
		},
		methods: {
			toggleRegion(regionName) {
				this.$emit('filter-region', regionName);
			},
			regionCount(region) {
				return this.$parent.regionCount(region);
			},
		},
	};
</script>

<template>
	<div v-if="regions.length" class="field">
		<template v-for="region in regions" :key="region.Id">
			<div class="control mb-2">
				<input name="checkbox"
					   type="checkbox"
					   :id="region.Id"
					   class="by-checkbox"
					   :value="region.Naam"
					   :checked="filterRegions.includes(region.Naam)"
					   @change="toggleRegion(region.Naam)" />
				<label :for="region.Id" class="by-checkable">
					{{ region.Naam }} ({{ regionCount(region.Naam) }})
				</label>
			</div>
		</template>
	</div>
</template>
